import React, { useEffect, useState } from 'react';
import UserProfile from '../components/Giftlist/UserProfile';
import useGlobal from '../store';
import LoadingOverlay from '../components/General/LoadingOverlay';
import Archive from '../components/Giftlist/Archive';
import Wishlist from '../components/Giftlist/Wishlist';
import EditGiftlist from '../components/Giftlist/EditGiftlist';
import GiftIdeas from '../components/General/GiftIdeas';
import { Spinner } from 'reactstrap';

const Giftlist = (props) => {

    const [user, actions] = useGlobal(
        state => state.activeGiftlist.user,
        actions => actions
    );
    const [ui] = useGlobal(
        state => state.ui.giftlist
    );
    const [giftlists] = useGlobal(
        state => state.giftlists
    );
    const [response] = useGlobal(
        state => state.response
    );

    const isOnNicelist = user ? giftlists.map(gl => gl.userID).indexOf(user.userID) >= 0 : true;

    useEffect(() => {
        console.log('GIFTLIST PROPS', props.match.params.uid);
        actions.uiActions.resetActiveGiftlist();
        actions.userActions.getUserById(props.match.params.uid);
        actions.userActions.getUserGiftlist(props.match.params.uid);
        actions.userActions.getUserArchive(props.match.params.uid);
    }, [props.match.params.uid, actions.userActions, actions.uiActions]);
    
    const renderTab = () => {
        if(!user) {
            return <></>;
        }
        switch(ui.activeTab) {
            case "giftlist":
                return <><Wishlist></Wishlist></>;
            case "giftideas":
                return <GiftIdeas user={user}></GiftIdeas>;
            case "editgiftlist":
                return <EditGiftlist user={user}></EditGiftlist>;
            case "archive":
                return <Archive></Archive>;
            default:
                return <></>;
        }
    }

    const [isAddingList, setIsAddingList] = useState(false);

    const addThisGiftlist = () => {
        setIsAddingList(true);
        let data = { userID : user.userID };
        console.log('ADD THIS GIFTLIST', data);
        actions.userActions.addGiftlist(data);
    }

    useEffect(() => {
        if(!response || response.type !== "addgiftlist") {
            return;
        }
        setIsAddingList(false);
    }, [response]);

    return (!user ? <div style={{minHeight:"300px"}} className="mt-5 kt-container kt-grid__item kt-grid__item--fluid"><LoadingOverlay height="10rem" width="10rem" color="primary" opacity="0.1"></LoadingOverlay></div> :
        <>
            <div className="kt-subheader kt-grid__item">
                <div className="kt-container">
                    <div></div>
                    <div className="kt-subheader__toolbar">
                        <div className="kt-subheader__wrapper">
                            <button onClick={() => actions.uiActions.toggleSidePanel("additem", { selectedUser: user })} className="kt-hidden-desktop btn btn-wide btn-bold btn-success btn-upper">
                                <i className="flaticon2-plus-1"></i> Add Item
                            </button>
                            <button onClick={() => actions.uiActions.toggleSidePanel("sharelists", { users: [user.userID] })} className="btn btn-wide btn-bold btn-info btn-upper">
                                <i className="flaticon2-send-1"></i> Share
                            </button>
                            {isOnNicelist ? <></> : <button onClick={() => addThisGiftlist()} className="btn btn-wide btn-bold btn-danger btn-upper">
                                <i className="flaticon2-plus-1"></i> Add This Gift List {isAddingList ? <Spinner></Spinner> : <></>}
                            </button>}
                        </div>
                    </div>
                </div>
            </div>
            <div style={{minHeight:"300px"}} className="mt-0 kt-container kt-grid__item kt-grid__item--fluid">						
                    <div className="row">	
                        <div className="col-sm-12">
                            <UserProfile></UserProfile>
                        </div>
                    </div>	

                    {renderTab()}
     
            </div>
        </>);
}


export default Giftlist;